import { isEligible } from '@/server-data'

export default function validateTimeWindowExceptionDate(
  date: string,
  eligibility: uui.domain.client.rm.Eligibility,
  recurrenceDate: uui.domain.YYYYMMDD | undefined,
): boolean {
  if (recurrenceDate) {
    return isEligible({ type: 'on', dates: [recurrenceDate] }, date)
  }

  return isEligible(eligibility, date)
}
